import {
  defaultFetch,
  httpMethod,
} from "@/scripts/Common/api";

import {
  getToken,
} from "@/scripts/Common/tokenService";

import {
  CreatePasswordChangeTicketV1Response,
  UpdateIdentityUserRequest,
  UserType,
} from "@/components/children/identityUsers/scripts/types";

const updateIdentityUser = async (userId: string, updateRequest: UpdateIdentityUserRequest)=> {
  const { error } = await defaultFetch({
    apiName: 'identityUsers',
    bearer: getToken(),
    body: JSON.stringify(updateRequest),
    options: {
      method: httpMethod.PUT,
      routeParams: {
        userId
      }
    }
  });

  return {
    error
  }
}

const changeIdentityUserState = async (userId: string, state: 'block' | 'unblock')=> {
  const { error } = await defaultFetch({
    apiName: 'changeIdentityUsersState',
    bearer: getToken(),
    options: {
      method: httpMethod.POST,
      routeParams: {
        userId,
        state
      }
    }
  });

  return {
    error
  }
}

const changeIdentityUserTypeState = async (userId: string, state: 'block' | 'unblock',  userType : UserType)=> {
  const { error } = await defaultFetch({
    apiName: 'changeIdentityUserTypeState',
    bearer: getToken(),
    options: {
      method: httpMethod.POST,
      routeParams: {
        userId,
        userType,
        state
      }
    }
  });

  return {
    error
  }
}

const deleteIdentityUser = async (userId: string)=> {
  const { error } = await defaultFetch({
    apiName: 'identityUsers',
    bearer: getToken(),
    options: {
      method: httpMethod.DELETE,
      routeParams: {
        userId
      }
    }
  });

  return {
    error
  }
}

const deleteIdentityUserType = async (userId: string, userType : UserType)=> {
  const { error } = await defaultFetch({
    apiName: 'identityUserType',
    bearer: getToken(),
    options: {
      method: httpMethod.DELETE,
      routeParams: {
        userId,
        userType
      }
    }
  });

  return {
    error
  }
}

const resetPasswordViaEmail = async (userId: string)=> {
  const { error } = await defaultFetch({
    apiName: 'identityUserResetPasswordViaEmail',
    bearer: getToken(),
    options: {
      method: httpMethod.POST,
      routeParams: {
        userId
      }
    }
  });

  return {
    error
  }
}


const createPasswordChangeTicket = async (userId: string)=> {
  const { error, response } = await defaultFetch({
    apiName: 'identityUserCreatePasswordChangeTicket',
    bearer: getToken(),
    options: {
      method: httpMethod.POST,
      routeParams: {
        userId
      },
    }
  });

  return {
    error,
    response: response as CreatePasswordChangeTicketV1Response
  }
}

export {
  updateIdentityUser,
  changeIdentityUserState,
  changeIdentityUserTypeState,
  deleteIdentityUser,
  deleteIdentityUserType,
  resetPasswordViaEmail,
  createPasswordChangeTicket
}

